export const initialState = {
    hdStationsList: null,
    activeHdStations:null
  };